<!--
  [Added by E2logy, 2025-07-09]
  Created new filter component which allows the user to select a specific value from the dropdown for filtering table rows.
  Usage: Use this component to filter data by selecting one or more values from a dynamically loaded dropdown list.
-->
<template>
  <div>
    <v-text-field
      hide-details
      v-model="searchString"
      v-bind:placeholder="$t('start_typing_to_search')"
      @input="searchItems"
    ></v-text-field>
    <div class="loading-spinner text-center mt-2 mb-2" v-if="isDataLoading">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div class="list_options" v-if="filteredList.length > 0">
      <v-checkbox
        v-for="item in filteredList"
        :key="getItemValue(item)"
        v-model="selectedValues"
        :label="item.title"
        :value="getItemValue(item)"
      ></v-checkbox>
    </div>
    <div v-else class="text-center">{{ $t("Empty data") }}</div>
  </div>
</template>

<script>
import ApiService from "@/services/apiService";
import { logInfo, logError } from "@/utils";

export default {
  name: "filterableAjaxFieldCheckboxesSimple",
  props: {
    // Use object syntax for props when you need more than just names
    value: {
      type: Array, // Assuming 'value' prop should be an array of selected IDs
      default: () => []
    },
    apiUrl: {
      type: String,
      required: false
    },
    columnName: {
      type: String,
      required: true
    },
    isFullText: {
      type: Boolean,
      default: false
    },
    criteria: {
      type: Object,
      default: () => ({})
    },
    isSearch: {
      type: Boolean,
      default: false
    },
    valueField: {
      // Correct way to define 'valueField' prop
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      isDataLoading: false,
      searchString: "",
      filteredList: [],
      selectedValues: [],
      fakeData: [
        { id: 1, title: "153548", code: "A1", name: "BrandA" },
        { id: 2, title: "7834684", code: "B2", name: "BrandB" },
        { id: 3, title: "3s1f7834684", code: "C3", name: "BrandC" },
        { id: 4, title: "87ew7834684", code: "D4", name: "BrandD" },
        { id: 5, title: "1357834684", code: "E5", name: "BrandE" }
      ]
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.selectedValues = Array.isArray(newVal) ? newVal : [];
      }
    },
    selectedValues(newVal) {
      this.$emit("input", newVal);
    },
    isSearch: function(newVal, oldVal) {
      if (this.columnName === "portal_photo_name" && newVal) {
        this.setSearchString("");
      }
    }
  },
  methods: {
    getItemValue(item) {
      return item[this.valueField] || item.id;
    },
    setSearchString(str) {
      this.searchString = str;
      this.getDataFromApi(this.searchString);
    },
    getFetchUrl(searchStr) {
      if (this.apiUrl.trim().length) {
        let fetch_url = this.apiUrl;
        let criteria = [
          "column=" + this.columnName,
          "filterValue=" + searchStr
        ];
        if (this.isFullText) {
          criteria.push("isFullText=true");
        }
        if (this.criteria && this.criteria?.brand_name) {
          criteria.push(
            "idBrands=" +
              Object.values(this.criteria.brand_name)
                .filter(el => el)
                .join(",")
          );
        }
        if (this.criteria && this.criteria?.survey_name) {
          criteria.push(
            "idSurveys=" +
              Object.values(this.criteria.survey_name)
                .filter(el => el)
                .join(",")
          );
        }
        fetch_url += "?" + criteria.join("&");
        return fetch_url;
      }
    },
    async searchItems() {
      this.getDataFromApi(this.searchString);
    },
    async getDataFromApi(searchString) {
      let fetch_url = this.getFetchUrl(searchString);
      this.isDataLoading = true;
      try {
        let response = await ApiService.get(fetch_url);
        if (response.data) {
          this.filteredList = response.data;
        }
        // this.filteredList = this.fakeData;
        this.isDataLoading = false;
      } catch (error) {
        logError(error);
        this.isDataLoading = false;
      }
    },
    init() {
      this.getDataFromApi("");
    }
  },
  async mounted() {
    this.init();
  }
};
</script>

<style>
.list_options {
  max-height: 300px;
  overflow-y: scroll;
}
.list_options .v-input--selection-controls {
  margin-top: 5px;
}
</style>
